/** ดึง URL PDF จาก response หลัง POST /factory/orders/parcel/print (รูปแบบ Speed) */
export function extractParcelLabelUrl(data: unknown): string | null {
  if (data == null || typeof data !== "object") return null;
  const root = data as Record<string, unknown>;

  const nested = root.data;
  if (Array.isArray(nested)) {
    const first = nested[0] as Record<string, unknown> | undefined;
    if (typeof first?.link === "string" && first.link.trim()) return first.link.trim();
    if (typeof first?.azure_url === "string" && first.azure_url.trim()) {
      return first.azure_url.trim();
    }
  }
  if (nested != null && typeof nested === "object" && !Array.isArray(nested)) {
    const obj = nested as Record<string, unknown>;
    if (typeof obj.link === "string" && obj.link.trim()) return obj.link.trim();
    if (typeof obj.azure_url === "string" && obj.azure_url.trim()) return obj.azure_url.trim();
  }
  if (typeof root.link === "string" && root.link.trim()) return root.link.trim();
  if (typeof root.azure_url === "string" && root.azure_url.trim()) return root.azure_url.trim();

  return null;
}
